var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"titleTop"},[_c('h5',{staticStyle:{"margin":"0"}},[_vm._v("\n        Interactive map distribution\n      ")])])]),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('div',{staticStyle:{"height":"300px"},attrs:{"id":"main"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-22da4075","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/bottomMap.vue
// module id = null
// module chunks = 